module.exports = __webpack_public_path__ + "static/img/stamp_01.acc96dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_01.jpg
// module id = 9MxQ
// module chunks = 7